<template>
    <div class="result-position-controls">
        <div class="controls">
            <div @click="collapseResult" class="collapse popover"
                 @mouseleave="hidePopover()"
                 @mouseenter="showPopover(getLocalizeByProp('groupTitle'), $event)">
                <icon name="collapse"
                      :fill="collapse ? 'var(--primary-color)' : 'var(--lighten-5-color)'"
                      width="20px" height="20px" />
            </div>
            <div @click="changeListType('grid')" class="controler popover"
                 @mouseleave="hidePopover()"
                 @mouseenter="showPopover(getLocalizeByProp('gridTitle'), $event)">
                <icon name="grid"
                      :fill="listType === 'grid' ? 'var(--primary-color)' : 'var(--lighten-5-color)'"
                      width="20px" height="20px" />
            </div>
            <div @click="changeListType('big-row')" class="controler popover"
                 @mouseleave="hidePopover()"
                 @mouseenter="showPopover(getLocalizeByProp('bigRowTitle'), $event)">
                <icon name="big-row"
                      :fill="listType === 'big-row' ? 'var(--primary-color)' : 'var(--lighten-5-color)'"
                      width="22px" height="22px" />
            </div>
            <div @click="changeListType('row')" class="controler popover"
                 @mouseleave="hidePopover()"
                 @mouseenter="showPopover(getLocalizeByProp('rowTitle'), $event)">
                <icon name="row"
                      :fill="listType === 'row' ? 'var(--primary-color)' : 'var(--lighten-5-color)'"
                      width="20px" height="20px" />
            </div>
            <div @click="changeListType('map')" class="controler popover"
                 @mouseleave="hidePopover()"
                 @mouseenter="showPopover(getLocalizeByProp('mapTitle'), $event)">
                <icon name="map-icon"
                      :fill="listType === 'map' ? 'var(--primary-color)' : 'var(--lighten-5-color)'"
                      width="20px" height="20px" />
            </div>
        </div>

    </div>
</template>

<script>
    import {bus} from "../../../../main";

    export default {
        name: "controls",
        props: {
            collapse: {
                type: Boolean,
                required: true
            },
            listType: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                collapseLoad: false,
            }
        },
        created() {
            bus.$on("hotels_collapse", (val) => {
                // this.collapse = val
                this.$parent.$parent.collapse = val
            });
        },
        methods: {
            collapseResult() {
                this.$parent.$parent.collapseResult();
            },
            getLocalizeByProp(prop) {
                return this.$parent.$parent.getLocalizeByProp(prop);
            },
            changeListType(text) {
                this.$parent.$parent.changeListType(text);
            },
            showPopover(text, e) {
                this.$parent.$parent.showPopover(text, e);
            }
        }
    }
</script>

<style scoped>

    .result-position-controls {
        background: var(--white-color);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
        padding: 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .result-position-controls .controls {
        display: flex;
        align-items: center;
    }

    .result-position-controls .controls > div {
        margin-right: 24px;
        cursor: pointer;
    }

    .result-position-controls .controls .collapse {
        position: relative;
    }

    .result-position-controls .controls .collapse:after {
        content: "";
        background-color: #e0e0e0;
        width: 1px;
        height: 20px;
        position: absolute;
        top: 2px;
        right: -13px;
    }

</style>